// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import RequestOrderChangeState from "@store/Framework/Store/Greif/Pages/RequestOrderChange/RequestOrderChangeState";
import {
    AddedItemModel,
    ChangeRequestModel,
} from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangePageContainer";
import { Draft } from "immer";

const initialState: RequestOrderChangeState = {
    newShipTo: {} as ShipToModel,
    newLines: [] as AddedItemModel[],
    changeRequestOrder: {} as ChangeRequestModel,
    isSubmitting: false,
    requestSubmitted: false,
    failedToSubmitRequest: false,
    errorMessage: undefined,
};

const actions = {
    "Greif/PagesReducer/RequestOrderChange/SetChangeRequestOrder": (
        draft: Draft<RequestOrderChangeState>,
        action: { changeRequestOrder: ChangeRequestModel },
    ) => {
        draft.changeRequestOrder = action.changeRequestOrder;
    },
    "Greif/PagesReducer/RequestOrderChange/UpdateChangeRequestOrder": (
        draft: Draft<RequestOrderChangeState>,
        action: { changeRequestOrder: ChangeRequestModel },
    ) => {
        draft.changeRequestOrder = action.changeRequestOrder;
    },
    "Greif/PagesReducer/RequestOrderChange/UpdateNewLines": (
        draft: Draft<RequestOrderChangeState>,
        action: { newLines: AddedItemModel[] },
    ) => {
        draft.newLines = action.newLines;
    },
    "Greif/PagesReducer/RequestOrderChange/SetNewContextualisedShipTo": (
        draft: Draft<RequestOrderChangeState>,
        action: { newShipTo: ShipToModel | undefined },
    ) => {
        draft.newShipTo = action.newShipTo;
    },
    "Greif/PagesReducer/RequestOrderChange/BeginSubmitRequest": (draft: Draft<RequestOrderChangeState>) => {
        draft.isSubmitting = true;
    },
    "Greif/PagesReducer/RequestOrderChange/FailedToSubmitRequest": (
        draft: Draft<RequestOrderChangeState>,
        action: { errorMessage: string | undefined },
    ) => {
        draft.isSubmitting = false;
        draft.failedToSubmitRequest = true;
        draft.errorMessage = action.errorMessage;
    },
    "Greif/PagesReducer/RequestOrderChange/CompleteSubmitRequest": (draft: Draft<RequestOrderChangeState>) => {
        draft.isSubmitting = false;
        draft.requestSubmitted = true;
    },
    "Greif/PagesReducer/RequestOrderChange/ClearChangeRequestOrder": (draft: Draft<RequestOrderChangeState>) => {
        draft.changeRequestOrder = initialState.changeRequestOrder;
        draft.newShipTo = initialState.newShipTo;
        draft.isSubmitting = initialState.isSubmitting;
        draft.requestSubmitted = initialState.requestSubmitted;
        draft.failedToSubmitRequest = initialState.failedToSubmitRequest;
        draft.errorMessage = initialState.errorMessage;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifOrderChangePagesActions = Parameters<typeof reducer>[1];
export default reducer;
